import { LDFlagSet, useFlags } from "launchdarkly-react-client-sdk";

const withFlags = (WrappedComponent: any) => (props: any) => {
    const flags: LDFlagSet = useFlags();

    return (
        <WrappedComponent
            {...props}
            flags={flags}
        />
    );
};

export default withFlags;